import { useEffect } from 'react';
import CrossTabConfig from 'worker-connection-library/calling-cross-tab-utils/CrossTabConfig';
import { crossTabConnectionManager } from 'calling-integration-cross-tab/connectionManagement/CrossTabConnectionManager';
import { useThirdPartyWidgetDetailsContext } from 'calling-remote-common/context/ThirdPartyWidgetDetailsContext';
import { useDispatch } from 'calling-remote-common/hooks/useDispatch';
import { isBroadcastSdkEvent } from 'calling-integration-cross-tab/types/BroadcastEvents';
import { handleBroadcastSdkEvents } from 'calling-integration-cross-tab/utils/handleBroadcastSdkEvents';
import { logDebugMessage } from 'calling-integration-cross-tab/utils/logDebugMessage';
export function useCrossTabConnectionManager() {
  const [, dispatch] = useThirdPartyWidgetDetailsContext();
  const {
    updateWidgetDetails
  } = useDispatch(dispatch);
  useEffect(() => {
    const conn = crossTabConnectionManager;
    conn.start();
    if (!conn.broadcastChannel) {
      return;
    }
    const handler = event => {
      const message = event.data;
      if (!message) {
        return;
      }

      // Ignore messages from self
      if (message.originConnectionId === CrossTabConfig.get().connectionId) {
        return;
      }
      if (isBroadcastSdkEvent(message.type)) {
        logDebugMessage(`Received message from Remote sdk event ${message.type}`, message);
        handleBroadcastSdkEvents(message, updateWidgetDetails);
      }
    };
    conn.broadcastChannel.addEventListener('message', handler);
    return () => {
      conn.broadcastChannel.removeEventListener('message', handler);
    };
  }, [updateWidgetDetails]);
}